import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

export interface IBreadcrumbs {
  url: string;
  label: string;
}

@Component({
  selector: 'artemis-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

  @Input() breadcrumbs: Array<IBreadcrumbs> = [];

  constructor(private router: Router) { }

  ngOnInit() {
  }

  /**
   * Redirect to corresponding page
   * @method redirect
   */
  redirect(destinationPage: IBreadcrumbs): void {
    if (destinationPage !== this.breadcrumbs[this.breadcrumbs.length - 1]) {
      this.router.navigateByUrl(destinationPage.url);
    }
  }
}
